export default "__VITE_ASSET__63d6b24e__"